import { array, date, number, object, string, boolean } from '@gogame/schemas';

import {
  APPLICATIONS,
  CONCEPT_FAMILIES,
  DESCRIPTION,
  EXPIRATION_DATE,
  ID,
  JIRA_TASK,
  NAME,
  REQUESTED_BY,
  TAGS,
  UNARCHIVE_DATE,
  AI_GENERATED,
} from 'scenes/Gallery/GalleryPage/Concepts/constants';

export const getValidationSchema = ({
  isAllowArchiving,
  isAllowJiraTask,
  isAllowConceptFamilies,
  isAllowRequestedBy,
}) => {
  let schema = object({
    [ID]: number().required('ID is required'),
    [NAME]: string().required('Name is required'),
    [APPLICATIONS]: array(number()).required('Applications is required'),
    [TAGS]: array(number()),
    [DESCRIPTION]: string(),
    [AI_GENERATED]: boolean(),
  });

  if (isAllowRequestedBy) {
    schema = schema.shape({
      [REQUESTED_BY]: number().required('Requested by is required'),
    });
  }
  if (isAllowJiraTask) {
    schema = schema.shape({
      [JIRA_TASK]: string(),
    });
  }

  if (isAllowArchiving) {
    schema = schema.shape({
      [EXPIRATION_DATE]: date(),
      [UNARCHIVE_DATE]: date(),
    });
  }

  if (isAllowConceptFamilies) {
    schema = schema.shape({
      [CONCEPT_FAMILIES]: array(number()),
    });
  }

  return schema;
};
